{
  "studio.navigation.editor": "Editor",
  "studio.navigation.screens": "Pantallas",
  "studio.navigation.templates": "Plantillas",
  "studio.navigation.components": "Componentes",
  "studio.navigation.aiGenerate": "Generar con IA",
  "studio.navigation.content": "Contenido",
  "studio.navigation.models": "Modelos",
  "studio.navigation.queries": "Consultas",
  "studio.navigation.forms": "Formularios",
  "studio.navigation.automations": "Automatizaciones",
  "studio.navigation.admin": "Administración",
  "studio.navigation.roles": "Roles",
  "studio.navigation.media": "Medios",
  "studio.navigation.extensions": "Extensiones",
  "studio.navigation.themes": "Temas",
  "studio.navigation.preview": "Vista previa",
  "studio.navigation.compatibility": "Compatibilidad",
  "studio.navigation.export": "Exportar",
  "studio.navigation.deploy": "Desplegar",
  "studio.navigation.help": "Ayuda",
  "studio.navigation.settings": "Configuración",
  "studio.sidebar.group.build": "Construir",
  "studio.sidebar.group.data": "Datos",
  "studio.sidebar.group.logic": "Lógica",
  "studio.sidebar.group.app": "App",
  "studio.sidebar.group.resources": "Recursos",
  "studio.sidebar.group.appearance": "Apariencia",
  "studio.sidebar.group.publish": "Publicar",
  "studio.sidebar.item.editor": "Editor",
  "studio.sidebar.item.screens": "Pantallas",
  "studio.sidebar.item.components": "Componentes",
  "studio.sidebar.item.templates": "Plantillas",
  "studio.sidebar.item.aiGenerate": "Generar con IA",
  "studio.sidebar.item.records": "Registros",
  "studio.sidebar.item.models": "Modelos",
  "studio.sidebar.item.dataSources": "Fuentes de datos",
  "studio.sidebar.item.queries": "Consultas",
  "studio.sidebar.item.workflows": "Acciones y workflows",
  "studio.sidebar.item.state": "Estado y variables",
  "studio.sidebar.item.forms": "Formularios",
  "studio.sidebar.item.navigation": "Navegación",
  "studio.sidebar.item.users": "Usuarios y permisos",
  "studio.sidebar.item.admin": "Administración",
  "studio.sidebar.item.media": "Medios",
  "studio.sidebar.item.extensions": "Extensiones",
  "studio.sidebar.item.themes": "Temas",
  "studio.sidebar.item.designSystem": "Sistema de diseño",
  "studio.sidebar.item.tokens": "Tokens",
  "studio.sidebar.item.preview": "Vista previa",
  "studio.sidebar.item.compatibility": "Compatibilidad",
  "studio.sidebar.item.export": "Exportar",
  "studio.sidebar.item.deploy": "Desplegar"
}
